// @flow
import PlanogramStorage, { type PlanogramStorageProps } from './planogram-storage';


export default PlanogramStorage;
export type { PlanogramStorageProps };
